import POST_COMPONENT_TYPE from '../postComponentType';
import LipoproteinAHero from '../../../assets/images/lipoprotein-a-hero-section.png';
import { TextBoxBackgroundColor } from '../../../components/BannerWithTextBox';
import { IconType } from '../../../components/BannerWithList';
import { BackgroundColor } from '../../../components/BannerWithTextAndDescription';

const lipoproteinAData = {
  key: 'lipoprotein-a',
  sectionList: [
    {
      type: POST_COMPONENT_TYPE.title,
      text: 'learnMoreContent.lipoprotein-a.name'
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextBox,
      image: LipoproteinAHero,
      text: 'learnMoreContent.lipoprotein-a.banner.text',
      backgroundColor: TextBoxBackgroundColor.RED
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.lipoprotein-a.importance.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.lipoprotein-a.importance.listItem1',
              type: 'text'
            },
            {
              text: 'learnMoreContent.lipoprotein-a.importance.listItem2',
              type: 'text',
              subItems: [
                {
                  text:
                    'learnMoreContent.lipoprotein-a.importance.listItem2.subItem1',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.lipoprotein-a.importance.listItem2.subItem2',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.lipoprotein-a.importance.listItem2.subItem3',
                  type: 'text'
                }
              ]
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.lipoprotein-a.overweight.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.lipoprotein-a.overweight.listItem1',
              type: 'text'
            },
            {
              text: 'learnMoreContent.lipoprotein-a.overweight.listItem2',
              type: 'text'
            },
            {
              text: 'learnMoreContent.lipoprotein-a.overweight.listItem3',
              type: 'text'
            }
          ]
        }
      ]
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.lipoprotein-a.measured.title',
      description: {
        text: 'learnMoreContent.lipoprotein-a.measured.description',
        type: 'text'
      },
      backgroundColor: BackgroundColor.GREEN
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.lipoprotein-a.improvement.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.lipoprotein-a.improvement.listItem1',
              type: 'text'
            },
            {
              text: 'learnMoreContent.lipoprotein-a.improvement.listItem2',
              type: 'text',
              subItems: [
                {
                  text:
                    'learnMoreContent.lipoprotein-a.improvement.listItem2.subItem1',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.lipoprotein-a.improvement.listItem2.subItem2',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.lipoprotein-a.improvement.listItem2.subItem3',
                  type: 'text'
                },
                {
                  text:
                    'learnMoreContent.lipoprotein-a.improvement.listItem2.subItem4'
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export default lipoproteinAData;